import { useQuery } from '@apollo/react-hooks';
import throwErrorInDev from '../helpers/throwErrorInDev';
/**
 * Takes in the orderHeaders query and optional query variables, and returns
 * the result and some helpers
 */
export default function useCustomerOrdersQuery({ query, variables }) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const result = useQuery(query, { variables });
    throwErrorInDev(!result.loading && !((_b = (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.customer) === null || _b === void 0 ? void 0 : _b.orderHeaders), 'Double-check that your query includes `{ customer { orderHeaders } }`');
    const orders = (_f = (_e = (_d = (_c = result === null || result === void 0 ? void 0 : result.data) === null || _c === void 0 ? void 0 : _c.customer) === null || _d === void 0 ? void 0 : _d.orderHeaders) === null || _e === void 0 ? void 0 : _e.result) !== null && _f !== void 0 ? _f : [];
    const totalOrders = (_j = (_h = (_g = result === null || result === void 0 ? void 0 : result.data) === null || _g === void 0 ? void 0 : _g.customer) === null || _h === void 0 ? void 0 : _h.orderHeaders) === null || _j === void 0 ? void 0 : _j.totalResults;
    return {
        // Default loading to true for SSR
        loading: result ? result.loading : true,
        orders,
        result,
        totalOrders
    };
}
//# sourceMappingURL=useCustomerOrdersQuery.js.map